import { useCallback } from 'react';

const STORAGE_KEY = 'biblika_game_history';

export function loadHistory() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
  } catch { return {}; }
}

function saveHistory(history) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(history));
}

export function clearHistory() {
  localStorage.removeItem(STORAGE_KEY);
}

export function getGameStats(gameId) {
  const history = loadHistory();
  return history[gameId] || { played: 0, correct: 0, wrong: 0 };
}

export function getAllStats() {
  const history = loadHistory();
  const games = Object.keys(history);
  const totals = games.reduce(
    (acc, g) => ({
      played: acc.played + history[g].played,
      correct: acc.correct + history[g].correct,
      wrong: acc.wrong + history[g].wrong,
    }),
    { played: 0, correct: 0, wrong: 0 }
  );
  return { ...totals, gamesWithHistory: games.length };
}

export default function useGameHistory(gameId) {
  const record = useCallback((isCorrect) => {
    const history = loadHistory();
    const prev = history[gameId] || { played: 0, correct: 0, wrong: 0 };
    history[gameId] = {
      played: prev.played + 1,
      correct: prev.correct + (isCorrect ? 1 : 0),
      wrong: prev.wrong + (isCorrect ? 0 : 1),
    };
    saveHistory(history);
  }, [gameId]);

  return { record };
}
